<script setup lang="ts">
import { computed } from 'vue'

interface GradientStop {
  color: string
  percentage?: number
}

const { darkMode = 'auto', gradientStops } = defineProps<{
  text?: string
  gradientStops?: GradientStop[]
  darkMode?: boolean | 'auto'
}>()

const gradientStopsStyle = computed<string>(() => {
  if (gradientStops == null) return ''
  return [
    /**
     * Tailwind only defines the direction when using
     * the gradient stop classes, so we need to specify it here.
     */
    'to right',
    ...gradientStops.map((stop) => {
      const percentage = stop.percentage != null ? `${stop.percentage}%` : ''
      return `${stop.color} ${percentage}`
    }),
  ].join(', ')
})
</script>

<template>
  <p
    :class="[
      'inline-block',

      // Animation
      'loading-text',

      // Clip background with text
      'text-transparent',
      'bg-linear-to-r',
      'bg-clip-text',

      gradientStops == null && [
        darkMode === true && 'from-canary-500 via-loading-text-canary to-canary-500',
        (darkMode === false || darkMode === 'auto') && 'from-grape-500 via-loading-text-grape to-grape-500',
        darkMode === 'auto' && 'dark:from-canary-500 dark:via-loading-text-canary dark:to-canary-500',
      ],
    ]"
    :style="gradientStops != null && { '--tw-gradient-stops': gradientStopsStyle }"
  >
    <slot v-if="!text" />
    <template v-else>{{ text }}</template>
  </p>
</template>

<style lang="postcss" scoped>
.loading-text {
  background-size: 200% auto;
  animation: slide 1.5s linear infinite;
  will-change: background-position;
  @keyframes slide {
    to {
      background-position: -200% center;
    }
  }

  animation-direction: normal;
  [dir='rtl'] & {
    animation-direction: reverse;
  }
}
</style>
